var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pt-5 pb-5 text-left" }, [
    _vm.compact
      ? _c("div", { staticClass: "compact" }, [
          _c("span", [_vm._v("1 Konservierungsstoff, ")]),
          _c("span", [_vm._v("2 Geschmacksver., ")]),
          _c("span", [_vm._v("3 Antioxidationsmittel, ")]),
          _c("span", [_vm._v("4 Farbstoff, ")]),
          _c("span", [_vm._v("5 Phosphat, ")]),
          _c("span", [_vm._v("6 Chinin, ")]),
          _c("span", [_vm._v("7 Koffein, ")]),
          _c("span", [_vm._v("8 geschwefelt, ")]),
          _c("span", [_vm._v("9 Saccharin, ")]),
          _c("span", [_vm._v("10 Aspartam/ Phenyl., ")]),
          _c("span", [_vm._v("11 Cyclamat, ")]),
          _c("span", [_vm._v("12 Acesulfam, ")]),
          _c("span", [_vm._v("13 geschwärzt, ")]),
          _c("span", [_vm._v("14 gewachst, ")]),
          _c("span", [_vm._v("15 gentechnisch, ")]),
          _c("span", [_vm._v("GL Gluten, ")]),
          _c("span", [_vm._v("EI Ei, ")]),
          _c("span", [_vm._v("ER Erdnüsse, ")]),
          _c("span", [_vm._v("FI Fisch, ")]),
          _c("span", [_vm._v("KR Krebstiere, ")]),
          _c("span", [_vm._v("LU Lupine, ")]),
          _c("span", [_vm._v("MI Milch, ")]),
          _c("span", [_vm._v("SC Schalenfrüchte, ")]),
          _c("span", [_vm._v("SL Sellerie, ")]),
          _c("span", [_vm._v("SF Senf, ")]),
          _c("span", [_vm._v("SE Sesamen, ")]),
          _c("span", [_vm._v("SJ Soja, ")]),
          _c("span", [_vm._v("WE Weichtiere")]),
        ])
      : _c(
          "div",
          [
            _c(
              "v-layout",
              { staticClass: "myLegend", attrs: { row: "", wrap: "" } },
              [
                _c("v-flex", { staticClass: "pa-2", attrs: { xs6: "" } }, [
                  _c("h3", [_vm._v("Zusatzstoffe")]),
                  _c("span", [_vm._v("1 Konservierungsstoff")]),
                  _c("span", [_vm._v("2 Geschmacksver.")]),
                  _c("span", [_vm._v("3 Antioxidationsmittel")]),
                  _c("span", [_vm._v("4 Farbstoff")]),
                  _c("span", [_vm._v("5 Phosphat")]),
                  _c("span", [_vm._v("6 Chinin")]),
                  _c("span", [_vm._v("7 Koffein")]),
                  _c("span", [_vm._v("8 geschwefelt")]),
                  _c("span", [_vm._v("9 Saccharin")]),
                  _c("span", [_vm._v("10 Aspartam/ Phenyl.")]),
                  _c("span", [_vm._v("11 Cyclamat")]),
                  _c("span", [_vm._v("12 Acesulfam")]),
                  _c("span", [_vm._v("13 geschwärzt")]),
                  _c("span", [_vm._v("14 gewachst")]),
                  _c("span", [_vm._v("15 gentechnisch")]),
                ]),
                _c("v-flex", { staticClass: "pa-2 pr-4", attrs: { xs6: "" } }, [
                  _c("h3", [_vm._v("Allergene")]),
                  _c("span", [_vm._v("A Gluten")]),
                  _c("span", [_vm._v("B Krebstiere")]),
                  _c("span", [_vm._v("C Eier von Geflügel")]),
                  _c("span", [_vm._v("D Fisch")]),
                  _c("span", [_vm._v("E Erdnüsse")]),
                  _c("span", [_vm._v("F Sojabohnen")]),
                  _c("span", [_vm._v("G Milch und Milcherzeugnisse")]),
                  _c("span", [_vm._v("H Schalenfrüchte")]),
                  _c("span", [_vm._v("L Sellerie")]),
                  _c("span", [_vm._v("M Senf")]),
                  _c("span", [_vm._v("N Sesamen")]),
                  _c("span", [_vm._v("O Schwefeloxid und Sulfite")]),
                  _c("span", [_vm._v("P Lupinen")]),
                  _c("span", [_vm._v("R Weichtiere")]),
                  _c("div", { staticClass: "badges mt-5" }, [
                    _c("img", {
                      staticClass: "mr-3",
                      attrs: {
                        src: require("../assets/icons/vegi.png"),
                        alt: "Vegetarisch",
                      },
                    }),
                    _c("img", {
                      staticClass: "mr-3",
                      attrs: {
                        src: require("../assets/icons/vegan-140.png"),
                        alt: "Vegan",
                      },
                    }),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }